import * as React from 'react';
import {StyleSheet, View} from 'react-native';
import Localized from 'src/constants/AppStrings';
import Styles from '../Styles';
import AVFormattedCurrency from './AVFormattedCurrency';
import AVText from './AVText';
import {connect} from 'react-redux';
import {RootState} from 'src/redux/store';

type BalanceContainerProps = {
  strings: typeof Localized;
  smallText?: boolean;
  textColor?: 'white' | 'primary';
  balance: number;
};
type BalanceContainerState = {
  balance: number;
};

class BalanceContainer extends React.Component<
  BalanceContainerProps,
  BalanceContainerState
> {
  static defaultProps = {
    smallText: false,
  };

  constructor(props: BalanceContainerProps) {
    super(props);
    this.state = {
      balance: props.balance,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.balance !== prevState.balance) {
      return {
        balance: nextProps.balance,
      };
    }
    return prevState;
  }

  getTextStyle() {
    switch (this.props.textColor) {
      default:
      case 'white':
        return styles.textWhite;

      case 'primary':
        return styles.textPrimary;
    }
  }

  getBalanceTextStyle() {
    switch (this.props.textColor) {
      default:
      case 'white':
        return styles.textWhite;

      case 'primary':
        return styles.textPrimaryBalance;
    }
  }

  render() {
    return (
      <View style={styles.container}>
        <View />
        <View style={styles.balanceContainer}>
          <AVText
            style={[
              this.getTextStyle(),
              styles.label,
              this.props.smallText && styles.labelSmall,
            ]}
          >
            {this.props.strings.Labels.your_balance}
          </AVText>
          <AVFormattedCurrency
            accessibilityLabel="balance"
            style={[
              this.getBalanceTextStyle(),
              styles.balance,
              this.props.smallText && styles.balanceSmall,
            ]}
            value={this.state.balance}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  balance: {
    alignSelf: 'flex-end',
    fontSize: Styles.Fonts.f3,
    fontWeight: '600',
  },
  balanceContainer: {
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  balanceSmall: {
    fontSize: Styles.Fonts.f2,
    fontWeight: '300',
  },
  container: {
    justifyContent: 'space-between',
  },
  label: {
    alignSelf: 'flex-end',
    fontSize: Styles.Fonts.f1,
    position: 'relative',
  },
  labelSmall: {
    fontSize: Styles.Fonts.f0,
  },
  textPrimary: {
    color: Styles.black,
  },
  textPrimaryBalance: {
    color: Styles.balanceColor,
  },
  textWhite: {
    color: Styles.white,
  },
});
export default connect((state: RootState) => ({
  balance: state.account.account.defaultBalance?.balance,
}))(BalanceContainer);
